/* =========================================================
   MADSPEED7 — CANDYRACK CART DRAWER SLIDER
   Cart drawer only
   ========================================================= */

(function () {

  function initCandyRackCartSlider() {

    const container = document.querySelector(
      '#candyrack-slider-cart'
    );

    if (!container) return;

    const list = container.querySelector(
      '.candyrack-slider-cart-offers-list'
    );

    const header = container.querySelector(
      '.candyrack-slider-cart-offers-header-wrapper'
    );

    if (!list || !header) return;

    

    /* ---------------------------------------------------------
       Create navigation arrows
       --------------------------------------------------------- */

    if (
      !header.querySelector(
        '.ms7-candyrack-slider-nav'
      )
    ) {

      const nav = document.createElement('div');

      nav.className = 'ms7-candyrack-slider-nav';

      const previousButton =
        document.createElement('button');

      previousButton.type = 'button';
      previousButton.className =
        'ms7-candyrack-slider-button';
      previousButton.setAttribute(
        'aria-label',
        'Previous products'
      );

      const previousChevron =
        document.createElement('span');

      previousChevron.className =
        'ms7-candyrack-chevron ms7-candyrack-chevron--left';

      previousButton.appendChild(
        previousChevron
      );

      const nextButton =
        document.createElement('button');

      nextButton.type = 'button';
      nextButton.className =
        'ms7-candyrack-slider-button';
      nextButton.setAttribute(
        'aria-label',
        'Next products'
      );

      const nextChevron =
        document.createElement('span');

      nextChevron.className =
        'ms7-candyrack-chevron ms7-candyrack-chevron--right';

      nextButton.appendChild(
        nextChevron
      );

      nav.appendChild(previousButton);
      nav.appendChild(nextButton);

      header.appendChild(nav);

      /* -------------------------------------------------------
         Navigation
         ------------------------------------------------------- */

            let isCandyRackSliderScrolling = false;
      let candyRackSliderScrollTimer = null;

      function updateButtons() {

        const maxScroll =
          list.scrollWidth - list.clientWidth;

        if (isCandyRackSliderScrolling) {

          previousButton.disabled = true;
          nextButton.disabled = true;

          return;

        }

        previousButton.disabled =
          list.scrollLeft <= 2;

        nextButton.disabled =
          list.scrollLeft >= maxScroll - 2;
      }

      function finishCandyRackSliderScroll() {

        isCandyRackSliderScrolling = false;

        if (candyRackSliderScrollTimer) {
          clearTimeout(candyRackSliderScrollTimer);
          candyRackSliderScrollTimer = null;
        }

        updateButtons();
      }

      function moveCandyRackSlider(distance) {

        if (isCandyRackSliderScrolling) {
          return;
        }

        isCandyRackSliderScrolling = true;

        updateButtons();

        list.scrollBy({
          left: distance,
          behavior: 'smooth'
        });

        /*
         * Modern browsers fire scrollend when the smooth
         * scroll has finished.
         */
        if ('onscrollend' in list) {

          list.addEventListener(
            'scrollend',
            finishCandyRackSliderScroll,
            { once: true }
          );

        }

        /*
         * Fallback for browsers that do not support scrollend.
         */
        candyRackSliderScrollTimer =
          setTimeout(
            finishCandyRackSliderScroll,
            500
          );

      }

      previousButton.addEventListener(
        'click',
        function () {

          moveCandyRackSlider(
            -(list.clientWidth * 0.82 + 12)
          );

        }
      );

      nextButton.addEventListener(
        'click',
        function () {

          moveCandyRackSlider(
            list.clientWidth * 0.82 + 12
          );

        }
      );

      list.addEventListener(
        'scroll',
        updateButtons,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        updateButtons
      );

      updateButtons();

    }

  }

    /* -----------------------------------------------------------
     CandyRack can render dynamically after page load.
     Watch for it and initialise when it appears.
     ----------------------------------------------------------- */

    function updateCandyRackDiscount() {

    const footer = document.querySelector(
      '#candyrack-slider-cart .candyrack-slider-cart-footer-subtotal-discounts-section'
    );

    if (!footer) return;

    let totalDiscount = 0;

    document
      .querySelectorAll(
        '#candyrack-slider-cart .candyrack-slider-cart-item-product-details-container'
      )
      .forEach(function (item) {

        const originalPrice =
          item.querySelector(
            '.candyrack-slider-cart-item-product-details-discounted-price'
          );

        const currentPrice =
          item.querySelector(
            '.candyrack-slider-cart-item-product-details-price'
          );

        const quantityInput =
          item.querySelector(
            '.candyrack-slider-cart-item-product-details-quantity-input'
          );

        if (!originalPrice || !currentPrice) return;

        const original =
          parseFloat(
            originalPrice.textContent.replace(/[^0-9.]/g, '')
          ) || 0;

        const current =
          parseFloat(
            currentPrice.textContent.replace(/[^0-9.]/g, '')
          ) || 0;

        const quantity =
          quantityInput
            ? parseInt(
                quantityInput.getAttribute('data-value') || '1',
                10
              )
            : 1;

        if (original > current) {

          totalDiscount +=
            (original - current) * quantity;

        }

      });

    let discountRow =
      footer.querySelector(
        '.ms7-candyrack-cart-discount-row'
      );

    if (totalDiscount <= 0) {

      if (discountRow) {
        discountRow.remove();
      }

      return;

    }

    if (!discountRow) {

      discountRow =
        document.createElement('div');

      discountRow.className =
        'ms7-candyrack-cart-discount-row';

      discountRow.innerHTML = `
        <span class="ms7-candyrack-cart-discount-label">
          Discount
        </span>
        <span class="ms7-candyrack-cart-discount-value"></span>
      `;

      const subtotal =
        footer.querySelector(
          '.candyrack-slider-cart-footer-subtotal-wrapper'
        );

      if (subtotal) {

        footer.insertBefore(
          discountRow,
          subtotal
        );

      }

    }

    const value =
      discountRow.querySelector(
        '.ms7-candyrack-cart-discount-value'
      );

    if (value) {

      value.textContent =
        '-£' + totalDiscount.toFixed(2);

    }

  }

  let discountUpdateTimers = [];

function scheduleCandyRackDiscountUpdate() {

  discountUpdateTimers.forEach(function (timer) {
    clearTimeout(timer);
  });

  discountUpdateTimers = [];

  [100, 300, 600, 1000, 1500].forEach(function (delay) {

    const timer =
      setTimeout(
        updateCandyRackDiscount,
        delay
      );

    discountUpdateTimers.push(timer);

  });

}

    const observer =
    new MutationObserver(function (mutations) {

      initCandyRackCartSlider();

      const candyRackChanged =
        mutations.some(function (mutation) {

          const target =
            mutation.target;

          if (
            target &&
            target.closest &&
            target.closest('#candyrack-slider-cart')
          ) {
            return true;
          }

          return Array.from(
            mutation.addedNodes
          ).some(function (node) {

            return (
              node.nodeType === 1 &&
              (
                node.matches &&
                node.matches('#candyrack-slider-cart, #candyrack-slider-cart *')
              )
            );

          });

        });

      if (candyRackChanged) {
        scheduleCandyRackDiscountUpdate();
      }

    });

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

  document.addEventListener(
    'DOMContentLoaded',
    function () {

      initCandyRackCartSlider();
      updateCandyRackDiscount();

    }
  );

  window.addEventListener(
    'load',
    function () {

      initCandyRackCartSlider();
      updateCandyRackDiscount();

    }
  );

})();